/* eslint react/jsx-no-bind:0 */
import React, { Component } from "react"
import { Row, Col, Table, MenuItem, DropdownButton } from "react-bootstrap";
import Dialog from 'react-bootstrap-dialog'
import { PropTypes } from "prop-types"
import { connect } from "react-redux"
import { red, blue, green, lightgray } from '../../../../utils/constants'

class Advancers extends Component {
  constructor(props) {
    super(props);
    this.handleOnDeleteAdvancer = this.handleOnDeleteAdvancer.bind(this);
    this.handleAddAdvancer = this.handleAddAdvancer.bind(this);
    this.handleUpdateAdvancer = this.handleUpdateAdvancer.bind(this);
    this.handleOnResendAdvancerEmail = this.handleOnResendAdvancerEmail.bind(this);
  }

  handleAddAdvancer() {
    const { onAddAdvancer } = this.props
    onAddAdvancer();
  }


  handleUpdateAdvancer(advancerId) {
    const { onUpdateAdvancer } = this.props;
    onUpdateAdvancer(advancerId);
  }

  handleOnResendAdvancerEmail(advancerId) {
    const customBody = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Are you sure you want to resend email to this advancer? </span>
      </p>
    )

    Dialog.setOptions({
      defaultOkLabel: 'Resend Email',
      defaultCancelLabel: 'Cancel',
      primaryClassName: 'btn-danger'
    })
    Dialog.Action(
      'Resend Email',
      () => this.props.onResendEmail(advancerId),
      'btn-danger'
    )
    this.dialog.show({
      body: customBody,
      title: 'Confirm resending email',
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => this.props.onResendEmail(advancerId))
      ],
      bsSize: 'small'
    })
  }

  handleOnDeleteAdvancer(advancerId) {
    const customBody = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Are you sure you want to remove this advancer? </span>
      </p>
    )

    Dialog.setOptions({
      defaultOkLabel: 'Remove',
      defaultCancelLabel: 'Cancel',
      primaryClassName: 'btn-danger'
    })
    Dialog.Action(
      'Remove Advancer',
      () => this.props.onDeleteAdvancer(advancerId),
      'btn-danger'
    )
    this.dialog.show({
      body: customBody,
      title: 'Confirm Advancer removal',
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => this.props.onDeleteAdvancer(advancerId))
      ],
      bsSize: 'small'
    })
  }

  render() {
    const { advancers, numberSpots, disabled, roleName, advancerUpdateInfo } = this.props
    if (advancerUpdateInfo.memberType == 'updatedAdvancer') {
      for (let i = 0; i < advancers.length; i++) {
        const dateOfBirth = new Date(advancerUpdateInfo.advancer.dob);
        let month = (dateOfBirth.getMonth() + 1);
        month = month > 9 ? month : '0' + month;
        let day = dateOfBirth.getDate();
        day = day > 9 ? day : '0' + day;
        const convertedDob = month + "/" + day + "/" + dateOfBirth.getFullYear();
        if (advancers[i].id === advancerUpdateInfo.advancer.advancerId) {
          advancers[i].calculatedDivision = advancerUpdateInfo.advancer.calculatedDivision;
          advancers[i].divisionId = advancerUpdateInfo.advancer.divisionId;
          advancers[i].dob = convertedDob;
          advancers[i].firstName = advancerUpdateInfo.advancer.firstName;
          advancers[i].lastName = advancerUpdateInfo.advancer.lastName;
          advancers[i].middleInitial = advancerUpdateInfo.advancer.middleInitial;
          advancers[i].addressLine1 = advancerUpdateInfo.advancer.addressLine1;
          advancers[i].addressLine2 = advancerUpdateInfo.advancer.addressLine2;
          advancers[i].city = advancerUpdateInfo.advancer.city;
          advancers[i].country = advancerUpdateInfo.advancer.country;
          advancers[i].state = advancerUpdateInfo.advancer.state;
          advancers[i].zip = advancerUpdateInfo.advancer.zip;
          advancers[i].emailAddress = advancerUpdateInfo.advancer.emailAddress;
          advancers[i].gender = advancerUpdateInfo.advancer.gender;
          advancers[i].membershipId = advancerUpdateInfo.advancer.membershipId;
          advancers[i].phoneNumber = advancerUpdateInfo.advancer.phoneNumber;
          advancers[i].parentGuardianEmail = advancerUpdateInfo.advancer.parentGuardianEmail;
          break;
        }
      }
    }
    const isAdministrator = roleName == 'Administrator';
    return (
      <div style={{ backgroundColor: 'white', padding: '10px', border: `1px solid ${lightgray}` }}>
        <Row>
          <Col xs={12}>
            <h4>Advancers</h4>
            <h4 style={{ color: blue, textDecoration: 'underline' }}>Number of advancers: {numberSpots}</h4>
            <button type='button' className="btn btn-default" style={{ color: green, fontWeight: 800, marginLeft: '10px', float: 'right' }} onClick={this.handleAddAdvancer} disabled={(disabled) || (numberSpots === advancers.length)}>
              <i className="fa fa-plus" aria-hidden="true" /> &nbsp;&nbsp;Add Advancer
            </button>
            <Dialog ref={(el) => { this.dialog = el }} />
            <Table striped>
              <thead>
                <tr>
                  <th />
                  <th>Name</th>
                  <th>Membership ID</th>
                  <th>Date of Birth</th>
                  <th>Calculated Division</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  advancers.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item.firstName + " " + item.lastName}</td>
                      <td>{item.membershipId}</td>
                      <td>{item.dob}</td>
                      <td>{item.calculatedDivision}</td>
                      <td>
                        {
                          !isAdministrator &&
                          <button type='button' className="btn btn-default" style={{ color: red, fontWeight: 800 }} onClick={() => this.handleOnDeleteAdvancer(item.id)}
                            disabled={disabled}>
                            <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Remove
                          </button>
                        }
                        {
                          isAdministrator &&
                          <DropdownButton pullRight noCaret title={<i className="fa fa-angle-right" />} id={"cloneActionBtn" + key}>
                            {
                              <div style={{ textAlign: 'left', paddingLeft: '10px' }}>
                                <MenuItem>
                                  <span style={{ color: red, fontWeight: 800 }} onClick={() => this.handleOnDeleteAdvancer(item.id)}>
                                    <i className="fa fa-remove  text-muted mr-sm" style={{ color: red }} />&nbsp;Remove
                                  </span>
                                </MenuItem>
                                <MenuItem>
                                  <span style={{ color: blue, fontWeight: 800 }} onClick={() => this.handleUpdateAdvancer(item.id)}>
                                    <i className="fa fa-refresh text-muted mr-sm" style={{ color: blue }} />&nbsp;Update
                                  </span>
                                </MenuItem>
                                <MenuItem>
                                  <span style={{ color: green, fontWeight: 800 }} onClick={() => this.handleOnResendAdvancerEmail(item.id)}>
                                    <i className="fa fa-envelope  text-muted mr-sm" style={{ color: green }} />&nbsp;Resend email
                                  </span>
                                </MenuItem>
                              </div>
                            }
                          </DropdownButton>
                        }
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          </Col>
        </Row >
      </div >
    );
  }
}

Advancers.propTypes = {
  onDeleteAdvancer: PropTypes.func,
  onAddAdvancer: PropTypes.func,
  onUpdateAdvancer: PropTypes.func,
  onResendEmail: PropTypes.func,
  advancers: PropTypes.array,
  advancerUpdateInfo: PropTypes.array,
  numberSpots: PropTypes.number,
  disabled: PropTypes.bool,
  roleName: PropTypes.string,
}

function mapStateToProps(state) {
  const roleName = state.user.roleName
  return {
    roleName
  }
}

export default connect(mapStateToProps)(Advancers)




// WEBPACK FOOTER //
// ./src/containers/postevent/components/recordAthletes/advancers.js